<template>
  <app-layout>
    <template #header>
      <h2 class="title">Account History
          <span v-if="for_user"> - {{ for_user.first_name }} {{ for_user.last_name }}</span></h2>
      <flash-messages />
    </template>

    <div class="py-2">
      <div>
        <div class="bg-white p-3">
   
          <table width="100%">
            <template v-for="order in orders" class="mb-3">
              <tr v-for="item in order.items">
                <td>{{ item.product_name }}</td>
                <td>Order #{{ order.id }}</td>
                <td width="150" align="right">{{ moment(order.date).format('M/D/YY h:mm A') }}</td>
              </tr>
            </template>
          </table>
          <div v-if="payments.length > 0">
            <strong>Payments</strong>
            <table width="100%">
              <template v-for="item in payments">
                <tr v-if="item.product">
                  <td>{{ item.product.name }}</td>
                  <td>Order #{{ item.order.id }}</td>
                  <td width="150" align="right">{{ moment(item.date).format('M/D/YY h:mm A') }}</td>
                </tr>
              </template>
            </table>
          </div>



        </div>
      </div>
    </div>
  </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import FlashMessages from '@/Shared/FlashMessages'
import Icon from '@/Shared/Icon'

import moment from 'moment'

export default {
    components: {
        AppLayout,
        FlashMessages,
        Icon
    },
  props: {
    user: Object,
    orders: Array,
    payments: Array,
    total_orders: Number,
    for_user: Object
  },
  data() {
    return {
      currentDate: moment()
    }
  },
  created: function () {
    this.moment = moment;
  },
}
</script>
